import {
  Container,
  NameLabel,
  RowCenter,
  StyledSkeleton,
} from './CompanyCardSkeleton.styled';
import { Skeleton } from '@mui/material';

interface ICompanyCardSkeletonProps {
  index: number;
  opacityCoefficient?: number;
}

const CompanyCardSkeleton = ({
  index,
  opacityCoefficient = 0.2,
}: ICompanyCardSkeletonProps) => {
  return (
    <Container opacityIndex={index} opacityCoefficient={opacityCoefficient}>
      <StyledSkeleton
        width={'90%'}
        height={'150rem'}
        animation="wave"
        variant="rectangular"
      />
      <RowCenter>
        <NameLabel>
          <Skeleton width={'70%'} animation="wave" />
          <Skeleton width={'60%'} animation="wave" />
        </NameLabel>
      </RowCenter>
    </Container>
  );
};
export default CompanyCardSkeleton;
